'use client'

import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/hooks/useAuth'
import { useWordFamiliarity } from '@/hooks/useContentFamiliarity'
import { cn } from '@/lib/utils'

export function WordFamiliarityBadge({
  entryId,
  className
}: {
  entryId: number | null | undefined
  className?: string
}) {
  const { user } = useAuth()
  const { data: status } = useWordFamiliarity(entryId)

  if (!user?.id || !status || status === 'new') return null

  if (status === 'reviewed') {
    return (
      <Badge variant="success" className={cn('text-[11px]', className)}>
        Reviewed
      </Badge>
    )
  }

  if (status === 'learning') {
    return (
      <Badge variant="secondary" className={cn('text-[11px]', className)}>
        Studying
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className={cn('text-[11px]', className)}>
      Saved
    </Badge>
  )
}
